import { BigNumber, type BigNumberProps } from './components/big-number'
import { Body, type BodyProps } from './components/body'
import { Caption, type CaptionProps } from './components/caption'
import { Subtitle, type SubtitleProps } from './components/subtitle'
import { Title, type TitleProps } from './components/title'

const Typography = {
  BigNumber: ({ variant = 'large-bold', ...props }: BigNumberProps) => (
    <BigNumber {...props} variant={variant} />
  ),
  Title: ({ variant = 'large-bold', ...props }: TitleProps) => (
    <Title {...props} variant={variant} />
  ),
  Subtitle: ({ variant = 'default-bold', ...props }: SubtitleProps) => (
    <Subtitle {...props} variant={variant} />
  ),
  Body: ({ variant = 'default-bold', ...props }: BodyProps) => (
    <Body {...props} variant={variant} />
  ),
  Caption: ({ variant = 'default-bold', ...props }: CaptionProps) => (
    <Caption {...props} variant={variant} />
  ),
} as const

export { Typography }
export type {
  BigNumberProps,
  TitleProps,
  SubtitleProps,
  BodyProps,
  CaptionProps,
}
